import { render } from "./Informer.vue?vue&type=template&id=5d2cb90c"
import script from "./Informer.vue?vue&type=script&lang=js"
export * from "./Informer.vue?vue&type=script&lang=js"

import "./Informer.vue?vue&type=style&index=0&id=5d2cb90c&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__